import React, { ReactNode } from "react";

interface IAvatarProps {
  children: ReactNode;
  color?: string;
  customClass?: any;
}

const Avatar: React.FC<IAvatarProps> = ({
  children,
  color,
  customClass = "",
}) => {
  return (
    <div
      className={`bg-${color} rounded-[24px] w-[48px] h-[48px] flex ${customClass}`}
    >
      {children}
    </div>
  );
};

export default Avatar;
